import $ from 'jquery';

$.ajax({
  url: '//munchkin.marketo.net/munchkin.js',
  dataType: 'script',
  cache: true,
  success: function () {
    Munchkin.init('396-LRB-524'); //eslint-disable-line no-undef
  }
});



/** WEBPACK FOOTER **
 ** ./src/js/core/munchkin.js
 **/